import { useQuery } from "@tanstack/react-query";
import { History, X } from "lucide-react";
import { api } from "../lib/api";

interface Props {
  noteId: string;
  onClose: () => void;
  onRestore: (content_md: string, title: string) => void;
}

export function RevisionsPanel({ noteId, onClose, onRestore }: Props) {
  const { data, isLoading } = useQuery({
    queryKey: ["revisions", noteId],
    queryFn: () => api.listRevisions(noteId, 20),
  });

  return (
    <div className="fixed inset-y-0 right-0 z-40 flex w-96 flex-col border-l border-zinc-800 bg-zinc-950 shadow-2xl">
      <header className="flex items-center justify-between border-b border-zinc-800 p-3">
        <div className="flex items-center gap-2 text-sm">
          <History className="h-4 w-4 text-zinc-400" />
          Revisionen
        </div>
        <button onClick={onClose} className="text-zinc-500 hover:text-zinc-200">
          <X className="h-4 w-4" />
        </button>
      </header>

      <div className="flex-1 overflow-y-auto">
        {isLoading && <div className="p-3 text-xs text-zinc-500">Lade…</div>}
        {data && data.length === 0 && (
          <div className="p-3 text-xs italic text-zinc-600">Noch keine Revisionen.</div>
        )}
        {data?.map((r) => (
          <article key={r.id} className="border-b border-zinc-800 p-3">
            <div className="mb-1 flex items-center justify-between">
              <span className="text-xs font-medium text-zinc-300">
                v{r.version} · {r.title}
              </span>
              <button
                onClick={() => {
                  if (window.confirm(`Revision v${r.version} wiederherstellen?`)) {
                    onRestore(r.content_md, r.title);
                  }
                }}
                className="text-xs text-emerald-400 hover:underline"
              >
                Restore
              </button>
            </div>
            <div className="mb-1 font-mono text-[10px] text-zinc-500">
              {new Date(r.created_at).toLocaleString("de-DE")}
            </div>
            <pre className="max-h-32 overflow-auto whitespace-pre-wrap rounded bg-zinc-900 p-2 font-mono text-[11px] text-zinc-400">
              {r.content_md.slice(0, 500)}
              {r.content_md.length > 500 && "…"}
            </pre>
          </article>
        ))}
      </div>
    </div>
  );
}
